/**
 * BFF route → page slug map (data) for dashboard-sonarprint.
 *
 * Single source of truth mapping a route to its BFF page slug. Injected into the BFF
 * config (`pageSlugByRoute`); the shared `useCurrentPageSlug` resolves the current
 * route against it so What's New fetches page-scoped entries. Only routes that have
 * (or will have) BFF content need an entry.
 *
 * @module BFF
 */

import { AUTH_ROUTES } from '@/Routes/consts/routes';

import type { PageSlug } from './types';

/**
 * Route path → BFF page slug. Keyed by each section's base route; nested routes resolve
 * to the same slug via longest-prefix match.
 */
export const BFF_PAGE_SLUG_BY_ROUTE: Partial<Record<string, PageSlug>> = {
  [AUTH_ROUTES.API]: 'api',
  [AUTH_ROUTES.REPORTS]: 'reports',
  [AUTH_ROUTES.GROUPS]: 'groups',
  [AUTH_ROUTES.DEVICE_BLOCKS]: 'device-blocks',
  [AUTH_ROUTES.DEVELOPER_SDK]: 'developer-sdk',
  [AUTH_ROUTES.DEVELOPER_BATCH]: 'developer-batch',
  [AUTH_ROUTES.DEVELOPER_CREDENTIALS]: 'developer-credentials',
  [AUTH_ROUTES.SETTINGS_OVERVIEW]: 'settings-overview',
  [AUTH_ROUTES.SETTINGS_USERS]: 'settings-users',
  [AUTH_ROUTES.SETTINGS_MY_ACCOUNT]: 'my-account',
};
